import Avatar from '@atlaskit/avatar';
import TeamAvatar from '@atlaskit/teams-avatar';
import React from 'react';
import { getAvatarSize } from './utils';
export class SizeableAvatar extends React.PureComponent {
  render() {
    const {
      src,
      presence,
      appearance,
      type = 'person'
    } = this.props;
    const props = {
      size: getAvatarSize(appearance),
      src,
      borderColor: 'transparent',
      presence
    };
    return type === 'team' ? /*#__PURE__*/React.createElement(TeamAvatar, props) : /*#__PURE__*/React.createElement(Avatar, props);
  }
}